"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var specification_1 = require("../specification");

exports.DataType = specification_1.DataType;
exports.DataKind = specification_1.DataKind;